import { useContext } from "react";
import { FileTsContext } from "features/user/contexts/FileTsContext";

export const useFileTsContext = () => useContext(FileTsContext);
